import '../App.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { NavLink } from 'react-router-dom';

const LeftsideMenu = () => {
  return (
    <div className="leftsideMenu">
        <ul className="menuBlock">
            <NavLink to="/" className="nav-link">
            <li><i className="bi bi-house"></i></li>
            </NavLink>
            <NavLink to="/about" className="nav-link">
            <li><i className="bi bi-person"></i></li>
            </NavLink>
            <NavLink to="/portfolio" className="nav-link">
            <li><i className="bi bi-info-circle"></i></li>
            </NavLink>
        </ul>
    </div>
  );
}

export default LeftsideMenu;